module.exports = __webpack_public_path__ + "img/partner8.6e37fc76.png";